export default class Cell{
	constructor(x,y,id){
		this.x = x;
		this.y = y;
		this.id = id;
		this.hovered = false
	}
	get locked(){
		if(this.tile) {
			return this.tile.locked
		}
	}
	get state(){
		return this.tile ? this.tile.state : 'empty'
	}
	placeTile(newTile){
		this.tile ? this.replaceTile(newTile) : this.tile = newTile
	}
	replaceTile(newTile){
		document.dispatchEvent(new CustomEvent("score", { detail: -50 }));
		this.tile = newTile;
		this.tile.state = 'destroy'
		setTimeout(()=>{
			this.tile.state = 'ready'
		},500)
	}
	destroyTile(){
		document.dispatchEvent(new CustomEvent("score", { detail: -50 }));
		this.tile.state = 'destroy'
		setTimeout(()=>{
			this.tile = null
		},500)
	}
}